import { React, useState } from "react";
import { 
  Button,
  Grid,
  GridColumn,
  GridRow,
  Header, 
  Icon,
} from "semantic-ui-react"

export default function Footer(props) {
  const { setSelection } = props
  const [b1Hovered, setB1Hovered] = useState(false)
  const [b2Hovered, setB2Hovered] = useState(false)
  const [b3Hovered, setB3Hovered] = useState(false)
  const [b4Hovered, setB4Hovered] = useState(false)
  const [b5Hovered, setB5Hovered] = useState(false)
  const [icon1Hovered, setIcon1Hovered] = useState(false)
	const [icon2Hovered, setIcon2Hovered] = useState(false)

  const footerItemStyle = {
    fontFamily: "'Lato', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
    marginBottom: "0.7em",
    padding: "0em",
    backgroundColor: "transparent",
    fontSize: "1em",
  }

  const footerItemStyleHover = {
    ...footerItemStyle,
    fontWeight: "bold",
    transition: "color 1s ease, border-bottom-color 1s ease",
  }

  const iconStyle = {
    color: "#FFFFFF",
  	opacity: "1",
  }

  const iconStyleHover = {
    ...iconStyle,
  }

  const h1Style = {
    fontFamily: "'B612', sans-serif",
    fontWeight: "400",
    color: "#FFFFFF",
		fontSize: "clamp(2.5em, 3vw, 3em)",
  }

  const pStyle = {
    fontFamily: "'Andika', sans-serif",
    color: "#FFFFFF",
    fontSize: "clamp(1.1em, 1vw, 1.4em)",
    lineHeight: "clamp(1.3em, 1.3vw, 1.5em)",
  }

  function PageSelectLandingPage() {
    setSelection("landingPage");
    window.scrollTo(0, 0);
  }

  function PageSelectAboutUs() {
    setSelection("aboutUs");
    window.scrollTo(0, 0);
  }

	function PageSelectContactUs() {
    setSelection("contactUs");
    window.scrollTo(0, 0);
  }

  return(
    <footer style={{ backgroundColor: "#212121" }}>
      <Grid
        stackable
        centered
        columns={2}
        style={{
          padding: "5em 1em 5em 1em",
        }}
      >
        <GridRow style={{ maxWidth: "1200px", }}>
          <GridColumn>
            <Header
              as="h1"
              content="Follow us"
              style={h1Style}
            />
            <Button
                href='https://www.facebook.com/profile.php?id=61559083412434'
                target='_blank'
                aria-label="Follow Custom Metal on Facebook"
                style={{
                  backgroundColor: "transparent",
                  padding: "0em",
                  margin: "0em",
                }}
              >
                <Icon 
                  name='facebook'
                  size='big'
                  onMouseEnter={() => setIcon1Hovered(true)}
                  onMouseLeave={() => setIcon1Hovered(false)}
                  style={icon1Hovered ? (iconStyleHover) : (iconStyle)}
                />
              </Button>
              <Button
                href='https://www.instagram.com/custom_metal_/'
                target='_blank'
                aria-label="Follow Custom Metal on Instagram"
                style={{
                  backgroundColor: "transparent",
                  padding: "0em",
                  margin: "0em",
                }}
              >
                <Icon 
                  name='instagram'
                  size='big'
                  onMouseEnter={() => setIcon2Hovered(true)}
                  onMouseLeave={() => setIcon2Hovered(false)}
                  style={icon2Hovered ? (iconStyleHover) : (iconStyle)}
                />
              </Button>
          </GridColumn>

          <GridColumn>
            <Header
              as="h1"
              content="Explore"
              style={h1Style}
            />
            <Button
              content='Home'
              onClick={PageSelectLandingPage}
              aria-label="Custom Metal home page"
              onMouseEnter={() => setB1Hovered(true)}
              onMouseLeave={() => setB1Hovered(false)}
              style={b1Hovered ? (footerItemStyleHover) : (footerItemStyle)}
            />
            <br/>
            <Button
              content='About Us'
              onClick={PageSelectAboutUs}
              aria-label="Learn more about Custom Metal"
              onMouseEnter={() => setB2Hovered(true)}
              onMouseLeave={() => setB2Hovered(false)}
              style={b2Hovered ? (footerItemStyleHover) : (footerItemStyle)}
            />
            <br/>
            <Button
              content='Contact Us'
              onClick={PageSelectContactUs}
              aria-label="Contact Custom Metal"
              onMouseEnter={() => setB3Hovered(true)}
              onMouseLeave={() => setB3Hovered(false)}
              style={b3Hovered ? (footerItemStyleHover) : (footerItemStyle)}
            />
            <br/>
            <Button
              content='Leave a Review'
              href='https://g.page/r/CZ5s_wUrbxOUEBM/review'
              target='_blank'
              aria-label="Leave a review for Custom Metal Tas"
              onMouseEnter={() => setB4Hovered(true)}
              onMouseLeave={() => setB4Hovered(false)}
              style={b4Hovered ? (footerItemStyleHover) : (footerItemStyle)}
            />
          </GridColumn>
        </GridRow>
      </Grid>

      <Grid>
        <GridRow>
          <GridColumn textAlign="right" style={{ padding: "0em 3em 1em 0em" }}>
            <p style={pStyle}>Website by&nbsp;
              <Button
                content='Zeteo'
                href='https://zeteo.studio/'
                target='_blank'
                aria-label="Visit Zeteo"
                onMouseEnter={() => setB5Hovered(true)}
                onMouseLeave={() => setB5Hovered(false)}
                style={b5Hovered ? (footerItemStyleHover) : (footerItemStyle)}
              />
            </p>
          </GridColumn>
        </GridRow>
      </Grid>
    </footer>
  )
}
